import type { UsageProduct, UsageProductInput } from '@vy/types';
import { useEffect, useState } from 'react';
import type { ChargeProviderSectionTitles } from '../utils/usage-products-utils';
import { getSectionTitle, getUsageProductsOrder } from '../utils/usage-products-utils';

export function useUsageProductsOrder(usageProducts: (UsageProduct | UsageProductInput)[]) {
  const [usageProductsOrder, setUsageProductsOrder] = useState<
    Set<'Tiers' | 'PerUnit' | 'Volume' | 'TieredSubscription'>
  >(getUsageProductsOrder(usageProducts));
  const [usageProductsTitles, setUsageProductTitles] = useState<ChargeProviderSectionTitles[]>(
    Array.from(usageProductsOrder).map((title) => getSectionTitle(title)),
  );

  useEffect(() => {
    setUsageProductsOrder((currentUsageProductsOrder) => {
      const currentOrderArray = Array.from(currentUsageProductsOrder);
      const newUsageProductsOrder = getUsageProductsOrder(usageProducts);
      const newOrderArray = Array.from(newUsageProductsOrder);

      const isMatching =
        currentOrderArray.every((item) => newOrderArray.includes(item)) &&
        newOrderArray.every((item) => currentOrderArray.includes(item));

      if (!isMatching) {
        setUsageProductTitles(
          newOrderArray.length ? newOrderArray.map((title) => getSectionTitle(title)) : [],
        );

        return newUsageProductsOrder;
      }

      return currentUsageProductsOrder;
    });
  }, [usageProducts, usageProductsOrder]);

  return [usageProductsOrder, usageProductsTitles] as const;
}
